import { useQuery } from "@tanstack/react-query";
import supabase from "../services/supabaseClient";

export const useRezultatai = ({ formosTipas, kasPildo, metai }) => {
   return  useQuery({
      queryKey: [
        "bendri_rezultatai",
        formosTipas,
        kasPildo,
        metai
      ],
      queryFn: async () => {
          const query = supabase.from('bendri_rezultatai', {

          }).throwOnError()
          .select('*');

          if (formosTipas) {
            query.eq('formos_tipas', formosTipas);
          }
          if (kasPildo) {
            query.eq('kas_pildo', kasPildo);
          }
          if (metai) {
            query.eq('metai', metai);
          }

          return await query;
      },
      enabled: true
    });
}